var map = {
	"./banner-news.png": "d267",
	"./different.jpg": "d36f",
	"./news-1.png": "b1f5",
	"./news-2.png": "f389",
	"./news-3.png": "7d5e",
	"./news-4.png": "9ca4",
	"./news-5.png": "9eac",
	"./news1.mp4": "5547",
	"./opi-asippindo.mp4": "26a8",
	"./opi-introduce.mp4": "aece",
	"./penjaminan-aman-asippindo.jpg": "2fe6",
	"./penjaminan-aman-ceo-orion.jpg": "3e3f",
	"./penjaminan-aman.jpg": "e232",
	"./press-release-min.png": "b0b2",
	"./press-release.png": "86f1",
	"./thumbnail-video-2.png": "34d5",
	"./thumbnail-video-3.png": "ce76",
	"./thumbnail-video.png": "a071",
	"./unit-usaha-syariah-pt-orion-penjaminan-indonesia.png": "6204"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f544";